import { Component } from '@angular/core';
import { CustomDriversLicenseComponent } from '../custom-drivers-license/custom-drivers-license.component';

@Component({
  moduleId: module.id,
  selector: 'custom-drivers-license-2021',
  templateUrl: './custom-drivers-license-2021.component.html',
})
export class CustomDriversLicenseComponent2021 extends CustomDriversLicenseComponent {}
